import { observer } from "mobx-react-lite";

import { SectionHeader } from "@pages/editor/components/SectionHeader";
import { SectionList } from "@pages/editor/components/SectionList";

import { AutofixMatchPanel } from "src/components/AutofixMatchPanel";
import { CliMatch } from "src/types/semgrep_output_v0_types";

import { LineNumber } from "./LineNumber";

interface Props {
  matches: CliMatch[];
  dirty: boolean;
  fixesApplied?: { [key: string]: boolean };
  onApplyFix?: (r: CliMatch) => () => void;
}

const Matches = ({ matches, dirty, fixesApplied, onApplyFix }: Props) => {
  return (
    <>
      <SectionHeader>Matches</SectionHeader>
      <SectionList>
        {matches.map((match) => (
          <li>
            <LineNumber line={match.start.line} />
            <div>{match.extra.message}</div>
            <AutofixMatchPanel
              item={match}
              fixes={match.extra.fixed_lines}
              dirty={dirty}
              fixesApplied={fixesApplied}
              onApplyFix={onApplyFix}
            />
          </li>
        ))}
      </SectionList>
    </>
  );
};

export const MatchesSection = observer(Matches);
